import { BRAND_NAME, language } from "@chef/constants";

export const brand = (
  {
    LMK: {
      mealboxSlugToPreferenceMap: new Map([
        ["vegetariskt", "vegetariskt"],
        ["familjefavoriter", "familjefavoriter"],
        ["linas-express", "snabbtochlattlagat"],
        ["vegan", "vegetariskt"],
        ["klassiskt-och-inspirerande", "kockensval"],
        ["viktvaktarna", "kalorismart"],
        ["glutenfri", "kockensval"],
        ["laktosfri", "kockensval"],
      ]),
    },
    AMK: {
      mealboxSlugToPreferenceMap: new Map([
        ["sunn-og-lett", "sunnoglett"],
        ["inspirasjon", "inspirasjon"],
        ["anbefalt", "inspirasjon-anbefalt"],
        ["laktosefri", "inspirasjon"],
        ["glutenfri", "inspirasjon"],
        ["vegetar", "vegetar"],
        ["ekspress", "ekspress"],
      ]),
    },
    GL: {
      mealboxSlugToPreferenceMap: new Map([
        ["ekspress", "raskeretter"],
        ["fleksiterianer", "vegetar-favoritter"],
        ["vegetarkassen", "vegetar"],
        ["roedekassen", "roede"],
        ["singelkassen", "singel"],
        ["favorittkassen", "favoritter"],
      ]),
    },
    RN: {
      mealboxSlugToPreferenceMap: new Map([
        ["vegetar", "vegetariske"],
        ["favoritter", "favoritter"],
        ["hurtig", "hurtige"],
        ["flexitar", "favoritter-vegetariske"],
      ]),
    },
  } as const
)[BRAND_NAME];

export const intl = (
  {
    no: {
      HOW_IT_WORKS: "Slik fungerer det",
      INGREDIENTS_YOU: "Ingredienser du",
      DO_NOT: "ikke",
      WANT: "vil ha",
      OPTIONAL: "valgfritt",
      WE_WILL_DO_OUR_BEST_TO_AVOID_THESE_INGREDIENTS:
        "Vi vil gjøre vårt beste for å unngå å foreslå noe du ikke liker eller ikke vil ha.",
      IS_THERE_ANYTHING_ELSE_YOU_DO_NOT_WANT:
        "Er det andre ingredienser du ikke vil ha?",
      MAKE_SURE_TO_READ_RECIPES:
        "Sørg for å lese gjennom ingredienslisten før du velger rettene dine. Allergener er markert.",
      BY_SAVING_YOU_ACCEPT_TERMS_AND_CONDITIONS:
        "Ved å lagre valgene dine aksepterer du at vi lagrer opplysninger om hva slags mat du liker, ikker liker, samt eventuelle allergier.",
      TERMS_AND_CONDITIONS: "Vilkår og betingelser",
      SELECT_SIZE: "Velg størrelse",
      PRO_TIP: "Tips!",
      IF_YOU_WANT_TO_CHOOSE_FULL_RANGE:
        "Hvis du vil velge blant alle rettene, kan du oppgradere til 2 personer",

      SAVE_CHANGES: "Lagre endringer",
      SELECTED_A_MIX: "Du har valgt en blanding av ulike typer retter.",
      WHAT_DISHES_DO_YOU_LIKE: "Hvilken type retter liker du?",
      FULL_MENU_IS_ALWAYS_AVAILABLE:
        "Du kan alltid bestille fra den fullstendige menyen - valgene dine hjelper oss å tilpasse din opplevelse.",
      CANNOT_DESELECT_INGREDIENTS:
        "Du kan ikke velge bort ingredienser i den ferdige matkassen, men du kan bytte retter.",
      OR_SELECT_FIXED:
        "Eller velg en ferdig matkasse, og la oss velge retter for deg",
      YOU_HAVE_SELECTED_FIXED:
        "Du har valgt en ferdig matkasse. Denne kan ikke kombineres med andre preferanser.",
      CANCEL: "Avbryt",
      CONTINUE_TO_CREATE_ACCOUNT: "Opprett konto",
      YOUR_DISCOUNT_CODE: "Din rabattkode",
      FOOD_FOR_N_PEOPLE: (portions: number) => `Mat til ${portions} personer`,
      FOOD_FOR_N_DISHES_PER_WEEK: (meals: number) =>
        `${meals} retter per levering`,
      ROUTE_PREFERENCE: "preferanser",
      ROUTE_PORTIONS: "pers",
      ROUTE_MEALS: "middager",
      ROUTE_TASTE: "uten",
      ROUTE_MEALBOX: "matkasse",

      DESIGN_YOUR_MEALKIT: "Sett sammen din matkasse",
      GET_EXCITED: "Gled deg!",
      CHOOSE_BETWEEN_XX_DISHES_EVERY_WEEK: (dishCount?: number) =>
        `Velg mellom ${dishCount} retter hver uke`,
      YOUR_CHOICE_OF_XX_WEEKLY_DISHES_IS_JUST_A_FEW_STEPS_AWAY: (
        dishCount: number,
      ) =>
        `om få klikk kan du velge blant ukens ${dishCount} forskjellige retter.`,
      CREATE_YOUR_ACCOUNT_TO_SEE_YOUR_FULL_MENU_AND_IF_YOU_WANT_SWAP_YOUR_MENU:
        "Opprett konto for å se hele menyen og legge til eller bytte ut retter.",
      YOUR_ACCOUNT_GIVES_YOU_ACCESS_TO_YOUR_PERSONALIZED_MENU_XX_DISHES_EACH_WEEK:
        (dishCount: number) => `
        Kontoen din gir deg adgang til din skreddersydde meny og ${dishCount} retter hver uke.`,
      BY_SELECTING_ALLERGENS_YOU_APPROVE_THAT_WE_CAN_STORE_YOUR_ALLERGIES:
        "Når du velger allergener, godkjenner du at vi lagrer informasjon om allergiene dine.",
    },
    se: {
      HOW_IT_WORKS: "Så fungerar det",
      INGREDIENTS_YOU: "Ingredienser du",
      DO_NOT: "inte",
      WANT: "vill ha",
      OPTIONAL: "valfritt",
      WE_WILL_DO_OUR_BEST_TO_AVOID_THESE_INGREDIENTS:
        "Vi gör vårt bästa för att undvika rätter med ingredienser du inte gillar eller vill ha.",
      IS_THERE_ANYTHING_ELSE_YOU_DO_NOT_WANT:
        "Finns det andra ingredienser du vill undvika?",
      MAKE_SURE_TO_READ_RECIPES:
        "Allergener är markerade i alla recept – läs noga innan du väljer rätter.",
      BY_SAVING_YOU_ACCEPT_TERMS_AND_CONDITIONS:
        "Genom att spara dina preferenser godkänner du att vi lagrar information om vilken mat du gillar, ogillar och eventuella allergener.",
      TERMS_AND_CONDITIONS: "Villkor och bestämmelser",
      SELECT_SIZE: "Välj storlek",

      // Specific for NO singel
      PRO_TIP: "",
      IF_YOU_WANT_TO_CHOOSE_FULL_RANGE: "",

      SAVE_CHANGES: "Spara ändringar",
      SELECTED_A_MIX: "Du har valt en blandning av olika typer av rätter.",
      WHAT_DISHES_DO_YOU_LIKE: "Vilken typ av rätter gillar du?",
      FULL_MENU_IS_ALWAYS_AVAILABLE:
        "Den fullständiga menyn finns alltid tillgänglig att beställa från – dina val hjälper oss enbart att anpassa din upplevelse.",
      CANNOT_DESELECT_INGREDIENTS:
        "Du kan inte välja bort ingredienser i matkassen med förvalda rätter, men du kan byta rätter.",
      OR_SELECT_FIXED: "Eller välj en matkasse med förvalda rätter",
      YOU_HAVE_SELECTED_FIXED:
        "Du har valt en matkasse med förvalda rätter, som inte kan kombineras med fler preferenser.",
      CANCEL: "Avbryt",
      CONTINUE_TO_CREATE_ACCOUNT: "Fortsätt för att skapa konto",
      YOUR_DISCOUNT_CODE: "Din aktuella rabattkod",
      FOOD_FOR_N_PEOPLE: (portions: number) => `Mat för ${portions} personer`,
      FOOD_FOR_N_DISHES_PER_WEEK: (meals: number) =>
        `${meals} rätter per leverans`,
      ROUTE_PREFERENCE: "preferenser",
      ROUTE_PORTIONS: "pers",
      ROUTE_MEALS: "middagar",
      ROUTE_MEALBOX: "matkasse",
      ROUTE_TASTE: "utan",

      DESIGN_YOUR_MEALKIT: "Skapa din matkasse",
      GET_EXCITED: "Spännande",
      CHOOSE_BETWEEN_XX_DISHES_EVERY_WEEK: (dishCount?: number) =>
        `Välj mellan ${dishCount} rätter varje vecka`,
      YOUR_CHOICE_OF_XX_WEEKLY_DISHES_IS_JUST_A_FEW_STEPS_AWAY: (
        dishCount: number,
      ) =>
        `med bara några klick kan du välja bland veckans ${dishCount} olika rätter.`,
      CREATE_YOUR_ACCOUNT_TO_SEE_YOUR_FULL_MENU_AND_IF_YOU_WANT_SWAP_YOUR_MENU:
        "Skapa ett konto för att se hela menyn och byta ut rätter.",
      YOUR_ACCOUNT_GIVES_YOU_ACCESS_TO_YOUR_PERSONALIZED_MENU_XX_DISHES_EACH_WEEK:
        (dishCount: number) => `
        Ditt konto ger dig tillgång till din skräddarsydda meny och ${dishCount} rätter varje vecka.`,
      BY_SELECTING_ALLERGENS_YOU_APPROVE_THAT_WE_CAN_STORE_YOUR_ALLERGIES:
        "Genom att välja bort allergener godkänner du att vi sparar information om dina val.",
    },
    dk: {
      HOW_IT_WORKS: "Sådan fungerer det",
      INGREDIENTS_YOU: "Ingredienser du",
      DO_NOT: "ikke",
      WANT: "ønsker",
      OPTIONAL: "valgfrit",
      WE_WILL_DO_OUR_BEST_TO_AVOID_THESE_INGREDIENTS:
        "Vi vil gøre vores bedste for at undgå at foreslå noget, du enten ikke kan lide eller ikke ønsker.",
      IS_THERE_ANYTHING_ELSE_YOU_DO_NOT_WANT: "Er der andet, du ikke ønsker?",
      MAKE_SURE_TO_READ_RECIPES:
        "Sørg for at læse opskrifternes ingrediensliste igennem, før du vælger retter. Allergener er fremhævet.",
      BY_SAVING_YOU_ACCEPT_TERMS_AND_CONDITIONS:
        "Ved at gemme dine præferencer accepterer du, at vi gemmer oplysninger om, hvilken slags mad du kan lide, ikke kan lide samt eventuelle allergener.",
      TERMS_AND_CONDITIONS: "Vilkår og betingelser.",
      SELECT_SIZE: "Vælg størrelse",

      // Specific for NO singel
      PRO_TIP: "",
      IF_YOU_WANT_TO_CHOOSE_FULL_RANGE: "",

      SAVE_CHANGES: "Gem ændringer",
      SELECTED_A_MIX: "Du har valgt en blanding af forskellige typer retter.",
      WHAT_DISHES_DO_YOU_LIKE: "Hvilken type retter kan du lide?",
      FULL_MENU_IS_ALWAYS_AVAILABLE:
        "Husk, at du altid kan vælge retter fra den fulde menu. Kategorierne nedenfor hjælper os blot med at forbedre dine menuforslag.",
      CANNOT_DESELECT_INGREDIENTS:
        "Du har valgt en færdig måltidskasse. Kan ikke kombineres med andre præferencer.",
      OR_SELECT_FIXED:
        "Eller vælg en færdig måltidskasse med forvalgte retter.",
      YOU_HAVE_SELECTED_FIXED:
        "Du kan ikke fravælge ingredienser i den færdige måltidskasse, men du kan ændre retter.",
      CANCEL: "Annuller",
      CONTINUE_TO_CREATE_ACCOUNT: "Fortsæt med at oprette konto",
      YOUR_DISCOUNT_CODE: "Din rabatkode",
      FOOD_FOR_N_PEOPLE: (portions: number) => `Mad til ${portions} personer`,
      FOOD_FOR_N_DISHES_PER_WEEK: (meals: number) =>
        `${meals} retter per levering.`,
      ROUTE_PREFERENCE: "praeferencer",
      ROUTE_PORTIONS: "pers",
      ROUTE_MEALS: "retter",
      ROUTE_MEALBOX: "maltidskasse",
      ROUTE_TASTE: "uden",

      DESIGN_YOUR_MEALKIT: "Design din måltidskasse",
      GET_EXCITED: "Glæd dig",

      YOUR_CHOICE_OF_XX_WEEKLY_DISHES_IS_JUST_A_FEW_STEPS_AWAY: (
        dishCount: number,
      ) =>
        `om få klik er du klar til at vælge blandt ugens ${dishCount} forskellige retter.`,
      CHOOSE_BETWEEN_XX_DISHES_EVERY_WEEK: (_?: number) =>
        `Vælg 5 retter hver uge`,
      CREATE_YOUR_ACCOUNT_TO_SEE_YOUR_FULL_MENU_AND_IF_YOU_WANT_SWAP_YOUR_MENU:
        "Opret din konto for at se den fulde menu og foretage ændringer",
      YOUR_ACCOUNT_GIVES_YOU_ACCESS_TO_YOUR_PERSONALIZED_MENU_XX_DISHES_EACH_WEEK:
        (dishCount: number) => `
        Din konto giver dig adgang til din skræddersyede menu ${dishCount} retter hver uge!`,
      BY_SELECTING_ALLERGENS_YOU_APPROVE_THAT_WE_CAN_STORE_YOUR_ALLERGIES:
        "Når du vælger allergener, godkender du, at vi gemmer oplysninger om dine allergier.",
    },
  } as const
)[language];
